import React from "react";
import Footer from "../component/Footer";
import YoutubeEmbed from "../component/YoutubeEmbed";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import CTA from "../component/CTA";
import { HiArrowUpRight } from "react-icons/hi2";

export default function Teaching1() {
  const clip = [
    {
      name: "ครูเติม",
      embedId: "FQP-G-FQpdo",
    },
    {
      name: "ครูเติม",
      embedId: "bqf-2-78-Ho",
    },
    {
      name: "ครูเติม",
      embedId: "zorzzRgr5ic",
    },
    {
      name: "ครูพี",
      embedId: "E2MLydekDpU",
    },
    {
      name: "ครูพี",
      embedId: "1G_-6Lzu9Q8",
    },
    {
      name: "ครูพี",
      embedId: "itWZwRXRVYY",
    },
    {
      name: "ครูมีน",
      embedId: "86BKpMA_H90",
    },
    {
      name: "ครูบิ๊ก",
      embedId: "_IvAzuiLv08",
    },
  ];

  return (
    <div>
      <div className=" py-24 sm:py-24 md:py-32">
        <div className="mx-auto max-w-screen-2xl px-6 lg:px-8">
          <div className="mx-auto max-w-7xl">
            <h2 className=" my-5 mx-auto max-w-max rounded-full bg-white px-5 py-1 text-center text-2xl font-extrabold  text-purple-500">
              Teaching Example
            </h2>
            <p className="mx-auto hidden max-w-5xl text-center text-6xl font-extrabold leading-tight tracking-tight  text-gray-800 sm:block sm:text-7xl lg:max-w-xl xl:max-w-5xl xl:text-9xl 2xl:max-w-5xl">
              <span className="text-purple-500">วิดีโอตัวอย่าง</span>
              การสอนของพวกเรา
            </p>
            <p className="mx-auto max-w-5xl text-center text-6xl   font-extrabold leading-tight tracking-tight text-gray-800 sm:hidden sm:text-9xl">
              <span className="text-purple-500">ตัวอย่าง</span>
              การสอนของเรา
            </p>
          </div>
          <div className="my-10">
            <YoutubeEmbed embedId="l-q3r3PY9AI" autoplay="1" />
          </div>
        </div>
      </div>
      {/* Kru Term */}
      <div className="mt-[-230px]  bg-white pb-24 pt-[200px] sm:mt-[-300px] sm:pt-[300px] sm:pb-32 2xl:mt-[-500px]  2xl:pt-[500px]">
        <div className="mx-auto max-w-screen-2xl  px-6 lg:grid lg:grid-cols-2 lg:px-8">
          <div className="mx-auto max-w-xl">
            <h2 className=" my-2 mx-auto inline-block rounded-full bg-slate-100 px-5 py-1 text-2xl font-extrabold  text-purple-500">
              Physics & Chemistry
            </h2>
            <p className="mt-2 text-5xl font-extrabold  leading-tight tracking-tight text-gray-800 sm:max-w-lg sm:text-7xl 2xl:max-w-2xl 2xl:text-8xl">
              ฟิสิกส์และเคมีโดย
              <span className="text-purple-500">ครูเติม</span>
            </p>
            <div className=" mt-8 flex items-center gap-x-4">
              <img
                src={`./img/kruterm.jpg`}
                alt=""
                className="h-14 w-14 rounded-full bg-gray-50"
              />
              <div className="text-lg leading-6">
                <p className="font-semibold text-gray-900">
                  <span className="absolute inset-0" />
                  ครูเติม
                </p>
                <p className="text-gray-600">ผู้บริหาร / ติวเตอร์</p>
              </div>
            </div>
            
          </div>
          <div>
            <OwlCarousel
              className=" owl-theme teaching mx-auto mt-10 overflow-hidden sm:mt-10 lg:mt-0"
              margin={30}
              items={1}
              // stagePadding={20}
              navText={[
                '<svg stroke="#000" fill="#000" stroke-width="0" viewBox="0 0 24 24" aria-hidden="true" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M11.03 3.97a.75.75 0 010 1.06l-6.22 6.22H21a.75.75 0 010 1.5H4.81l6.22 6.22a.75.75 0 11-1.06 1.06l-7.5-7.5a.75.75 0 010-1.06l7.5-7.5a.75.75 0 011.06 0z" clip-rule="evenodd"></path></svg>',
                '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24"  height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke="#000" stroke-width="2" d="M2,12 L22,12 M13,3 L22,12 L13,21"></path></svg>',
              ]}
              nav
            >
              {clip.map((item, idx) => {
                if (item.name === "ครูเติม") {
                  return (
                    <YoutubeEmbed
                      embedId={item.embedId}
                      key={idx}
                      autoplay="0"
                    />
                  );
                }
              })}
            </OwlCarousel>
          </div>
        </div>
      </div>

      {/* Kru Pee*/}

      <div className="bg-white py-24 sm:py-32">
        <div className="mx-auto max-w-screen-2xl  px-6 lg:grid lg:grid-cols-2 lg:px-8">
          <div className="mx-auto max-w-xl lg:hidden">
            <h2 className=" my-2 mx-auto inline-block rounded-full bg-slate-100 px-5 py-1 text-2xl font-extrabold  text-purple-500">
              Math
            </h2>
            <p className="mt-2 text-6xl font-extrabold  leading-tight tracking-tight text-gray-800 sm:max-w-md sm:text-7xl 2xl:max-w-2xl 2xl:text-8xl">
              คณิตศาสตร์โดย
              <span className="text-purple-500">ครูพี</span>
            </p>
            <div className=" mt-8 flex items-center gap-x-4">
              <img
                src="./img/krupee.jpg"
                alt=""
                className="h-14 w-14 rounded-full bg-gray-50"
              />
              <div className="text-lg leading-6">
                <p className="font-semibold text-gray-900">
                  <span className="absolute inset-0" />
                  ครูพี
                </p>
                <p className="text-gray-600">ติวเตอร์</p>
              </div>
            </div>
          </div>
          <div>
            <OwlCarousel
              className=" owl-theme teaching mx-auto mt-10 overflow-hidden sm:mt-10 lg:mt-0"
              margin={30}
              items={1}
              // stagePadding={20}
              navText={[
                '<svg stroke="#000" fill="#000" stroke-width="0" viewBox="0 0 24 24" aria-hidden="true" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M11.03 3.97a.75.75 0 010 1.06l-6.22 6.22H21a.75.75 0 010 1.5H4.81l6.22 6.22a.75.75 0 11-1.06 1.06l-7.5-7.5a.75.75 0 010-1.06l7.5-7.5a.75.75 0 011.06 0z" clip-rule="evenodd"></path></svg>',
                '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24"  height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke="#000" stroke-width="2" d="M2,12 L22,12 M13,3 L22,12 L13,21"></path></svg>',
              ]}
              nav
            >
              {clip.map((item, idx) => {
                if (item.name === "ครูพี") {
                  return (
                    <YoutubeEmbed
                      embedId={item.embedId}
                      key={idx}
                      autoplay="0"
                    />
                  );
                }
              })}
            </OwlCarousel>
          </div>
          <div className="mx-auto hidden max-w-xl lg:block lg:max-w-sm 2xl:max-w-xl">
            <h2 className=" my-2 mx-auto inline-block rounded-full bg-slate-100 px-5 py-1 text-2xl font-extrabold  text-purple-500">
              Math
            </h2>
            <p className="mt-2  text-3xl font-extrabold leading-tight tracking-tight text-gray-800 sm:text-7xl 2xl:text-8xl">
              คณิตศาสตร์โดย
              <span className="text-purple-500">ครูพี</span>
            </p>
            <div className=" mt-8 flex items-center gap-x-4">
              <img
                src="./img/krupee.jpg"
                alt=""
                className="h-14 w-14 rounded-full bg-gray-50"
              />
              <div className="text-lg leading-6">
                <p className="font-semibold text-gray-900">
                  <span className="absolute inset-0" />
                  ครูพี
                </p>
                <p className="text-gray-600">ติวเตอร์</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Kru Mean & Kru Big */}

      <div className="bg-slate-100 py-24 sm:py-32">
        <div className="mx-auto max-w-screen-2xl grid-cols-2 gap-20 px-6 lg:grid lg:px-8">
          <div>
            <div className="mx-auto md:max-w-xl lg:max-w-none">
              <h2 className=" my-2 mx-auto inline-block rounded-full bg-white px-5 py-1 text-2xl font-extrabold  text-purple-500">
                Biology
              </h2>
              <p className="mt-2  text-5xl font-extrabold leading-tight tracking-tight text-gray-800 sm:text-7xl 2xl:text-8xl">
                ชีวะโดย
                <span className="text-purple-500">ครูมีน</span>
              </p>
              <div className=" mt-8 flex items-center gap-x-4">
                <img
                  src="./img/krumean.jpg"
                  alt=""
                  className="h-14 w-14 rounded-full bg-gray-50"
                />
                <div className="text-lg leading-6">
                  <p className="font-semibold text-gray-900">
                    <span className="absolute inset-0" />
                    ครูมีน
                  </p>
                  <p className="text-gray-600">ติวเตอร์</p>
                </div>
              </div>
            </div>
            <div className="my-10">
              {clip.map((item, idx) => {
                if (item.name === "ครูมีน") {
                  return (
                    <YoutubeEmbed
                      embedId={item.embedId}
                      key={idx}
                      autoplay="0"
                    />
                  );
                }
              })}
            </div>
          </div>

          <div className="pt-24 sm:pt-24 lg:pt-0">
            <div className="mx-auto md:max-w-xl lg:max-w-none">
              <h2 className=" my-2 mx-auto inline-block rounded-full bg-white px-5 py-1 text-2xl font-extrabold  text-purple-500">
                English
              </h2>
              <p className="mt-2 text-5xl font-extrabold  leading-tight tracking-tight text-gray-800 sm:max-w-md sm:text-7xl 2xl:max-w-2xl 2xl:text-8xl">
                ภาษาอังกฤษโดย
                <span className="text-purple-500">ครูบิ๊ก</span>
              </p>
              <div className=" mt-8 flex items-center gap-x-4">
                <img
                  src="./img/krubig.jpg"
                  alt=""
                  className="h-14 w-14 rounded-full bg-gray-50"
                />
                <div className="text-lg leading-6">
                  <p className="font-semibold text-gray-900">
                    <span className="absolute inset-0" />
                    ครูบิ๊ก
                  </p>
                  <p className="text-gray-600">ติวเตอร์</p>
                </div>
              </div>
            </div>
            <div className="my-10">
              {clip.map((item, idx) => {
                if (item.name === "ครูมีน") {
                  return (
                    <YoutubeEmbed
                      embedId={item.embedId}
                      key={idx}
                      autoplay="0"
                    />
                  );
                }
              })}
            </div>
          </div>
        </div>
      </div>

      <CTA />

      <Footer />
    </div>
  );
}
